import React from 'react';
import styled from 'styled-components';
import { colors } from '@omilia/theme';
import Icon from '@omilia/icon';
import { Text } from '@omilia/typography';

const SContainer = styled.div`
  align-items: center;
  border-radius: 5px;
  border: 1px solid ${colors.COLOR_RED_600};
  box-shadow: inset 3px 0 0 0 ${colors.COLOR_RED_600};
  box-sizing: border-box;
  display: flex;
  flex: 1;
  margin-bottom: 18px;
  padding: 13px 27px;
`;

const SErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 10;
`;

const SIcon = styled(Icon)`
  flex: 1;
`;

type Errors = string | string[];

export const getNormalizedErrors = (errors: Errors) =>
  typeof errors === 'string' ? [errors] : errors;

const Alert = ({ errors }: { errors: Errors }) => {
  const errorMessages = getNormalizedErrors(errors);

  return errorMessages.length > 0 ? (
    <SContainer data-test="alert-dialog">
      <SIcon
        glyph="notification-warning"
        primaryColor={colors.COLOR_RED_600}
        size="18"
      />
      <SErrorContainer>
        {errorMessages.map(errorMessage => (
          <Text key={errorMessage} level={4}>
            {errorMessage}
          </Text>
        ))}
      </SErrorContainer>
    </SContainer>
  ) : null;
};

export default Alert;
